// API Gateway rejects expired or revoked sessions before application handlers run.
// Keep application permission/quota failures separate from session expiry.
export function sessionRejected(status, body, hasToken) {
  return Boolean(hasToken && (status === 401 || (status === 403 && ['Forbidden', 'Unauthorized'].includes(body?.message))));
}
export function sessionError() { return Object.assign(new Error('Your session has expired. Please sign in again.'), { sessionExpired: true, status: 401 }); }
export function clearProductSession() { localStorage.removeItem('drop_access_token'); sessionStorage.removeItem('drop_access_token'); }
